import { OfferGenreViewModel } from "./../../../node_modules/@playcharge/common/models/backend/offers/offer-genre-view-model";
import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ApiRoutes } from "../models/constants/api-routes";
import { ApiUtils } from "../utils/api-utils";

@Injectable({
    providedIn: "root",
})
export class ApiOfferGenresService {
    private _httpClient = inject(HttpClient);

    public getAll(): Observable<OfferGenreViewModel[]> {
        return this._httpClient.get<OfferGenreViewModel[]>(
            ApiUtils.buildUserUrl(ApiRoutes.genres.root),
        );
    }
}
